var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 358 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A2Soft") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "evolution-color",
    x1: 0,
    y1: 48,
    x2: 118,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7190ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4a8f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#evolution-color)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 63 30 1 60 63H18L23.5 51.5H41.5L30 27.5 12.8 63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 13.5 77.6 2H96.5C108.8 2 117 9.3 117 20.3 117 30.5 109.8 35.4 100.6 39.1L90.7 43.1C85.4 45.2 83.6 47.2 83.6 51.5H117L111.5 63H72V53.4C72 42.5 76.3 37.1 85.8 33.2L96.8 28.6C102.5 26.3 105.4 24.1 105.4 20.3 105.4 16 102.1 13.5 96.5 13.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#f4f5fb",
    strokeWidth: 10.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171 7.5H146.5C138.4 7.5 132 12.9 132 20.4 132 28 137.8 31.5 146.5 31.5H156.5C165 31.5 171 36.3 171 44.4 171 52.6 164.9 57.5 156.5 57.5H130.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 6.5,
    width: 48,
    height: 51,
    rx: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 63V7.5H298M260 32H289M312 7.5H358M335 7.5V63"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1136105f80fae3cda0f500d6f49330c9.svg";
export { ForwardRef as ReactComponent };